import {Page} from "../../Page";
import {$} from "../../Application";

export class ListUsers extends Page {
    constructor(private searchParams = new URLSearchParams(window.location.search)) {
        super();

    }
    runOnCurrentPage(): boolean {
        return $('.list-users-page').length > 0;
    }

    registerEventHandlers() {
        super.registerEventHandlers();
        $('table').on('submit', '[name="decline-form"]', (e) => {
            e.preventDefault();

            const findForm = (input): JQuery => {
                return $(input).is('form') ? $(input) : findForm($(input).parent());
            }

            const reason = prompt('Ablehnungsgrund:');
            if(reason && reason.length > 1) {
                const $form = findForm(e.currentTarget[0]);
                $form.find('[name="reason"]').val(reason);
                ($form[0] as any).submit();
            } else {

            }
        });
    }

    onReady() {
    }
}
